<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="the-coming-of-the-train">
<h1>The Coming of the Train</h1>
<p style="text-align: center;">There is only</p>
<p style="text-align: center;">Hello</p>
<p style="text-align: center;">then</p>
<p style="text-align: center;">In Between</p>
<p style="text-align: center;">and then</p>
<p style="text-align: center;">Goodbye</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?e0859888